import React from 'react';
import { Card } from "react-bootstrap";
import face_gergo_orban from "../../assets/img/face_gergo_orban.jpg";
import ShowMoreText from "react-show-more-text";
import proj_deepgen from "../../assets/img/proj_deepgen.png";

const Gergo_Orban_deepgen = () => {
    return (
        <Card className="CARD2" bg="dark">
        {/* <Card.Title><h2>Psychological characteristics behind (academic) performance</h2></Card.Title> */}

        <Card.Img variant="top" src={proj_deepgen} />
        <br />
        <Card.Body>
          <Card.Text className="ct1">
            {" "}
            <img
              className="img2"
              src={face_gergo_orban}
              /* this will be the text on the banner */
              alt="Deep Generative Models"
            />{" "}
            <p className="text7">Gergő Orbán</p>
            <br />
            <p className="text8">
              Group Leader{" "}
            </p>
            <p className="text8">Wigner Research Centre for Physics</p>
          </Card.Text>
          <ShowMoreText lines={1}>
            <div>
            In recent years, generative models have proven to be immensely effective 
            in learning a flexible mapping from a conditioning signal, as well as a 
            compressed representation, of high dimensional and versatile continuous 
            data, most prominently natural images. The most successful example of this 
            family were diffusion models and Variational Autoencoders (VAEs). The goal 
            of the project is twofold. First, to adapt conditional diffusion models to 
            learn a mapping from a different, biological conditioning signal: the spiking 
            activity of neurons recorded during visual perception, giving rise to a neurally 
            driven diffusion model that decodes natural images from neural responses. Second, 
            to explore how inductive biases — in particular, attention mechanisms — shape and 
            improve the representations learned by VAEs. Through the development of these models, 
            there is an opportunity to learn the theory of deep generative models, and get acquainted 
            with the foundations and tools of a central branch of modern machine learning: unsupervised 
            learning, spanning both conditional generation and representation learning.


            <br />
            <br />
            The project requires knowledge about probability theory, the principles of unsupervised 
            learning, as well as experience with modern scientific programming tools: 
            python + pytorch / tensorflow.



            </div>
          </ShowMoreText>
        </Card.Body>
      </Card>
    );
};

export default Gergo_Orban_deepgen;